<template>
  <div class="row">
    <div class="col-12">
      <div class="tile">
        <div class="form-inline">
          <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword" v-on:keydown.enter="load" :placeholder="$t('keyword')" />
          <form-select class="mr-1 mb-1" :model="filterFormModel" :options="statusOptions" @change="load" attribute="status"></form-select>
          <time-range-picker class="mr-1 mb-1" :model="filterFormModel" :label="$t('time')" @change="load"></time-range-picker>
          <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
          <button @click="() => {reset(); load()}" class="btn btn-secondary mr-1 mb-1">Reset</button>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="c-paging clearfix">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <div class="c-paging__right">
          <div class="c-paging__numbers">
            <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                          v-model="filterFormModel.page" :total-rows="itemCount"
                          :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12" v-if="items.length">
      <div class="c-smart-table tile">
        <div class="row c-smart-table__title">
          <div class="col-lg-6">{{ $t('callTo') }}</div>
          <div class="col-lg-6">{{ $t('callInfo') }}</div>
        </div>
        <div class="row" v-for="item in items" :key="item._id">
          <div class="col-lg-6">
            <div><b>{{ $t('phone') }}:&nbsp;</b><span>{{ item.phone }}</span></div>
            <div v-if="item.name"><b>{{ $t('name') }}:&nbsp;</b><span>{{ item.name }}</span></div>
            <div v-if="item.desc"><b>{{ $t('desc') }}:&nbsp;</b><span>{{ item.desc }}</span></div>
            <div v-if="campaign.contactCustomFields && item.customFields">
                <span v-for="f in item.customFields" v-bind:key="f.key">
                  <div v-for="c in campaign.contactCustomFields" v-bind:key="c._id">
                    <span v-if="!c.isOutputData && c.key === f.key">
                      <b>{{ c.label }}:</b>
                      <span class="h-word-break">{{getCustomFieldValue(f)}}</span>
                    </span>
                  </div>
                </span>
            </div>
            <div v-if="item.user"><b>{{ $t('inboundFollowByLastCall') }}:&nbsp;</b><span>{{item.user.name}}</span></div>
          </div>
          <div class="col-lg-6">
            <div>
              <b>{{ $t('createTime') }}:&nbsp;</b>
              <span>{{ item.createTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
            </div>
            <div v-if="item.updateTime">
              <b>{{ $t('updateTime') }}:&nbsp;</b>
              <span>{{ item.updateTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
            </div>
            <div v-if="item.reviveTime">
              <b>{{ $t('reviveTime') }}:&nbsp;</b>
              <span>{{ item.reviveTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
            </div>
            <div v-if="item.revivedBy">
              <b>{{ $t('revivedBy') }}:&nbsp;</b>
              <span>{{ item.revivedBy.name }} ({{item.revivedBy.email}} - {{item.revivedBy.ext}})</span>
            </div>
            <div>
              <b>{{$t('dialCount')}}: </b><span>{{item.dials && item.dials.length ? item.dials.filter(dial => dial.call || dial.createTime > Date.now() - 60 * 60 * 1000).length : 0}}</span>
              <!--                <b>{{$t('dialCount')}}: </b><span>{{item.dials && item.dials.length ? item.dials.length : 0}}</span>-->
            </div>
            <div>
              <label v-if="item.finishTime > 0" class="badge badge-success">{{ $t('finished') }}</label>
              <!--                <label v-else-if="item.status" class="badge badge-info">{{ $t(item.status) }}</label>-->
              <label v-else-if="!item.finishTime" class="badge badge-danger">{{ $t('notFinished') }}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 text-center text-danger" v-if="!items.length">
      <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
      <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
    </div>

    <div class="col-12" v-if="itemCount">
      <div class="c-paging__count" v-if="itemCount">
        {{ $t('found', [itemCount]) }}
      </div>
      <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                    v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                    @input="load">
      </b-pagination>
    </div>
  </div>
</template>

<script>
import List from '@/mixins/List';
import CRUD from "@/mixins/CRUD";
import TimeRangePicker from "@/components/TimeRangePicker";
import moment from 'moment';

export default {
  components: {TimeRangePicker},
  props: ['campaign'],
  mixins: [List, CRUD],
  data() {
    return {
      autoLoad: true,
      service: 'call-campaign-contact/' + this.campaign._id,
      afterLoad: function () {
        this.items.forEach(item => {
          if (item.dials) {
            item.dials.reverse();
          }
        })
      },
      defaultFilterFormModel: {
        campaign: this.campaign._id,
        statusType: 'dial',
        keyword: '',
        status: null,
      },
      statusOptions: [
        {value: null, text: this.$t('all')},
        {value: 'activated', text: this.$t('finished')},
        {value: 'deactivated', text: this.$t('notFinished')}
      ],
    }
  },
  i18n: {
    messages: {
      en: {
        callTo: "Call to",
        callInfo: "Call info",
        index: "Time {0}",
        ok: "Ok",
        deny: "Deny",
        failed: "Failed",
        callback: "Call back",
        notReported: "Chưa báo cáo",
        callTime: "Call at",
        finished: "Finished",
        notFinished: "Not finished",
        allResults: "All results",
        contactList: "Contact list",
        inboundFollowByLastCall: "Last call user",
      },
      vi: {
        callHistory: "Danh sách liên hệ",
        callHistoryTitle: "Danh sách liên hệ: ",
        callTo: "Gọi tới",
        callInfo: "Thông tin cuộc gọi",
        index: "Lần {0}",
        ok: "Đồng ý",
        deny: "Từ chối",
        failed: "Thất bại",
        callback: "Hẹn gọi lại",
        notReported: "Chưa báo cáo",
        callTime: "Gọi lúc",
        finished: "Hoàn thành",
        notFinished: "Chưa hoàn thành",
        allResults: "Tất cả kết quả",
        dialCount: "Số lần gọi",
        contactList: "Danh sách liên hệ",
        inboundFollowByLastCall: "Nhân viên gọi gần nhất",
      }
    }
  },
  methods: {
    show() {
      this.showList = true;
      this.load();
    },
    getCustomFieldValue: function (f) {
      let items = [];
      if (this.campaign.contactCustomFields) {
        items = this.campaign.contactCustomFields.filter(field => field.key === f.key);
      }
      if (items.length > 0) {
        let customField = items[0];
        let context = f.val && f.val.length === 1 ? f.val[0] : f.val.join(", ");
        if(customField.inputType === 'number') {
          context = new Intl.NumberFormat().format(context);
        } else if(customField.inputType === 'date') {
          context = moment(Number(context)).format('DD/MM/YYYY HH:mm:ss');
        }
        return context;
      } else {
        return "";
      }
    },
  }
}
</script>
<style>
.modal-content-2 {
  background-color: #e5e5e5;
}
</style>
